var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivityLog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H14V14H4V16Z",
    fill: "#currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H4V10H14V12Z",
    fill: "#currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H8V6H4V8Z",
    fill: "#currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H15C16.6569 20 18 18.6569 18 17V7C18 3.13401 14.866 0 11 0H3ZM3 2H10V7H16V17C16 17.5523 15.5523 18 15 18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2ZM12 2.10002C13.6113 2.4271 14.9413 3.52906 15.584 5H12V2.10002Z",
    fill: "#currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivityLog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/activity-log.d842ecce09b35256c63e63d62c0113ce.svg";